import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { supabase } from "@/integrations/supabase/client";

export const AuthLogo = () => {
  const { t } = useTranslation();
  const [logo, setLogo] = useState("");

  useEffect(() => {
    const loadLogo = async () => {
      const { data } = await supabase
        .from('app_settings')
        .select('value')
        .eq('key', 'platform_branding')
        .maybeSingle();

      if (data?.value) {
        const branding = data.value as {
          logo?: string;
          logoResponsive?: string;
        };
        // Use responsive logo for auth pages (smaller screens typical)
        setLogo(branding.logoResponsive || branding.logo || "");
      }
    };

    loadLogo();
  }, []);

  return (
    <Link to="/" className="inline-flex items-center gap-2 mb-4">
      {logo ? (
        <img 
          src={logo} 
          alt={t("common.appName")}
          className="h-12 object-contain"
        />
      ) : (
        <>
          <div className="w-12 h-12 bg-primary border-[3px] border-dark flex items-center justify-center font-heading font-bold text-2xl">
            I
          </div>
          <span className="font-heading font-bold text-2xl text-dark">
            {t("common.appName")}
          </span>
        </>
      )}
    </Link>
  );
};